import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HypertensionPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Hypertension</h1>
        <section className="mb-8">
          <p>Hypertension, or high blood pressure, is a common condition that can lead to serious health complications if left untreated. Our natural therapies focus on regulating blood pressure, improving circulation, and promoting overall cardiovascular health through gentle, holistic approaches.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor diet and high salt intake</li>
            <li>Lack of physical activity</li>
            <li>Stress and anxiety</li>
            <li>Obesity</li>
            <li>Genetic factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Headaches</li>
            <li>Dizziness</li>
            <li>Shortness of breath</li>
            <li>Chest pain</li>
            <li>Vision problems</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use blood pressure-regulating herbs, stress management techniques, and lifestyle modifications to naturally manage hypertension. Our approach focuses on improving circulation, reducing stress, and maintaining healthy blood pressure levels through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural blood pressure regulation</li>
            <li>Improved cardiovascular health</li>
            <li>No harsh side effects</li>
            <li>Long-term management</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Follow a heart-healthy diet</li>
            <li>Regular exercise</li>
            <li>Stress management</li>
            <li>Limit salt intake</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment replace blood pressure medication?</strong>
            <p>A: While herbal treatments can help manage blood pressure, always consult with your healthcare provider before making changes to your medication.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural approach is gentle and suitable for long-term management of hypertension.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see results?</strong>
            <p>A: Many patients notice improvement in blood pressure levels within a few weeks of starting treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Take control of your blood pressure—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default HypertensionPage; 